export function hashCode(s: string) {
  let h = 0;
  let i = 0;

  while (i < s.length) {
    h = (Math.abs((h << 5) + (h >> 3)) + s.charCodeAt(i++)) | 0;
  }

  return h >>> 0;
}

export function getPercentage(val: number, min: number, max: number): number {
  if (max === min) {
    return 0;
  }
  const clamped = Math.max(min, Math.min(val, max));
  return ((clamped - min) / (max - min)) * 100;
}
